export default function TS_Home() {
  return (
    <div>
      <h1>TS HOME</h1>
      <p>This is the TS HOME page.</p>
    </div>
  );
}